export enum RouteName {
  appCatalog = 'marketplace-manager-app-catalog',
}
